package one.healthium.profile.ui.update_name

import one.healthium.domain.user.UserModel

internal data class UpdateNameUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
    val updatedName: String? = null,
) {
    val name = updatedName ?: userModel?.profile?.name
    val isNameChanged = updatedName != null && updatedName.trim() != userModel?.profile?.name
}
